<template>
    <input ref="minuteinput"
           type="text"
           @input="inputEvent($event)"
           @keydown="keyDownEvent($event)"
           class="form-control"
           :value="displayvalue"
           @blur="validateMinuteInput($event)"
           :disabled="disabled"
           autocomplete="off">
</template>

<script>
    export default {
        name: "MinuteInput",

        props: {
            disabled: {
                required:false,
            },
            value: {
                type: String | null,
                required: true
            },
        },

        computed: {
            displayvalue: function () {

                if (!this.value){
                    return null;
                }

                return this.value / 60
            }
        },

        methods: {
            keyDownEvent(event) {
                if (event.key === 'Enter') {
                    this.validateMinuteInput(event);
                }
            },

            inputEvent(event) {
                let typedvalue = event.target.value;

                // replace al non numeric chars by space. exluding the:
                typedvalue = typedvalue.replace(/[,.]/g, ':');
                typedvalue = typedvalue.replace(/[^0-9:]/g, '');  // replace the dot and comma by a :

                this.tempvalue = typedvalue;

                this.$refs['minuteinput'].value = this.tempvalue;
            },

            validateMinuteInput(event){
                this.$emit('input', event.target.value * 60);
                this.$emit('change', event.target.value * 60);
            }
        }
    }
</script>

<style scoped>

</style>
